import { ApiPaths } from 'api/constants';
import {
  AddTenantParams,
  AddTenantResult,
  TenantData,
  TenantGeneral,
  TenantRole,
  UpdateTenantResult,
} from 'api/endpoints/tenants';
import { SystemUserPermissions, User } from 'api/endpoints/users';
import ApiUrlParams from 'constants/apiUrlParams';
import BaseRepo from 'container/BaseRepo';
import { ApiResponseAsync } from 'container/models';

import { ITenantsRepo } from './ITenants';

export class TenantsRepo extends BaseRepo implements ITenantsRepo {
  addTenant = (name: string): ApiResponseAsync<TenantGeneral> => {
    const link = ApiPaths.tenants._();
    const payload: AddTenantParams = {
      name: name,
    };

    return this.helpers.handlePost<AddTenantParams, AddTenantResult>(
      link,
      payload
    );
  };

  updateTenant = (tenant: TenantGeneral): ApiResponseAsync<TenantGeneral> => {
    const link = ApiPaths.tenants.byId._({
      [ApiUrlParams.tenantId]: tenant.id,
    });
    const payload: TenantData = {
      name: tenant.name,
    };

    return this.helpers.handlePut<TenantData, UpdateTenantResult>(
      link,
      payload
    );
  };

  getTenants = (): ApiResponseAsync<DataWithTotal<TenantGeneral>> =>
    this.helpers.handleGet(ApiPaths.tenants._());

  addUserToTenant = (
    tenant: TenantGeneral,
    user: User,
    role: TenantRole,
    permissions: SystemUserPermissions
  ): ApiResponseAsync<void> =>
    this.helpers.handlePostAction(
      ApiPaths.tenants.byId.users._({
        [ApiUrlParams.tenantId]: tenant.id,
      }),
      {
        users: [{ userId: user.id, tenantRole: role, permissions }],
      }
    );

  removeUserFromTenant = (
    tenant: TenantGeneral,
    user: User
  ): ApiResponseAsync<void> =>
    this.helpers.handleDelete(
      ApiPaths.tenants.byId.users.byId._({
        [ApiUrlParams.userId]: user.id,
        [ApiUrlParams.tenantId]: tenant.id,
      })
    );

  updateUserInTenant = (
    tenant: TenantGeneral,
    user: User,
    role: TenantRole,
    permissions: SystemUserPermissions
  ): ApiResponseAsync<void> =>
    this.helpers.handlePut(
      ApiPaths.tenants.byId.users.byId._({
        [ApiUrlParams.userId]: user.id,
        [ApiUrlParams.tenantId]: tenant.id,
      }),
      {
        tenantRole: role,
        permissions,
      }
    );
}
